import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, currency = 'GBP') {
  const symbols = { GBP: '£', EUR: '€', USD: '$', DKK: 'kr' };
  const symbol = symbols[currency] || currency;
  const formattedValue = Math.abs(value).toLocaleString('en-GB', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return value >= 0 ? `${symbol}${formattedValue}` : `-${symbol}${formattedValue}`;
}

/** Extract the street name from a full Smoobu-style property title.
 *  "North Castle Street, 6 Beds, Large Central..." -> "North Castle Street" */
export function shortPropertyName(name) {
  if (!name) return name;
  const idx = name.indexOf(',');
  return idx > 0 ? name.substring(0, idx).trim() : name;
}

export function formatDate(date, format = 'short') {
  const d = new Date(date);
  if (format === 'short') {
    return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  }
  return d.toISOString().split('T')[0];
}

/**
 * Derive the effective invoice status from payment data and due date.
 *
 * If amount_paid < total_amount AND due_date is in the past, the invoice
 * is overdue regardless of the stored status. Terminal statuses
 * (paid, cancelled, void) are never overridden.
 *
 * Single source of truth: both Revenue and Costs pages import this
 * helper for display and sort. Do not hand-roll overdue checks.
 */
export function deriveInvoiceStatus(inv) {
  const s = inv.status || 'unknown';
  if (s === 'paid' || s === 'cancelled' || s === 'void') return s;
  if (!inv.due_date) return s;
  const paid = inv.amount_paid ?? 0;
  const total = inv.total_amount ?? 0;
  if (paid < total) {
    const today = new Date().toISOString().slice(0, 10);
    if (inv.due_date < today) return 'overdue';
  }
  return s;
}
